import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><circle cx="12" cy="12" r="10" fill="#fff" /><path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z" /></g>,<defs key="1"></defs>,]
, 'DisplayClosedCircleFilledx');
